$(document).ready(function () {
  (function ($) {
    // Add ids to our h2s in the body
    $('.article__body h2').each(function (index, element) {
      element.id = element.innerText.toLowerCase().replace(/ /g, '-')
    })

    // link the .sidebox__headings to the h2s
    $('.sidebox.sidebox--outline .sidebox__headings h2').each(function (index, element) {
      var id = element.innerText.toLowerCase().replace(/ /g, '-')
      $(element).wrap('<a href="#' + id + '"></a>')
    })

    function throttle(fn, wait) {
      var time = Date.now()
      return function() {
        if ((time + wait - Date.now()) < 0) {
          fn();
          time = Date.now()
        }
      }
    }

    var $sidebox = $('.js-sidebox-outline-container')
    var $header = $('#header')
    var $footer = $('#footer')

    if ($sidebox.length && window.innerWidth >= 850) {
      var headerHeight = $header.height()
      var sideboxWidth = $sidebox.width()
      var isFixed = false
      var originalOffsetTop = null

      window.addEventListener('scroll', throttle(function () {
        var scrollTop = $(window).scrollTop()
        var documentHeight = $(document).height()
        var windowHeight = $(window).height()

        // Get the CURRENT offset of the sidebox
        var currentOffset = $sidebox.offset().top
        var sideboxHeight = $sidebox.outerHeight()

        // Cache the original position when first seen as static
        if (!isFixed && originalOffsetTop === null) {
          originalOffsetTop = currentOffset
        }

        // Calculate footer position
        var footerTop = documentHeight - $footer.outerHeight()

        // Should it be fixed? When we've scrolled far enough that the element would go above the header
        var shouldBeFixed = scrollTop + headerHeight >= originalOffsetTop

        // Check if fixed sidebox would collide with footer
        var sideboxBottomIfFixed = scrollTop + headerHeight + sideboxHeight
        var wouldCollideWithFooter = sideboxBottomIfFixed >= footerTop

        if (shouldBeFixed && !isFixed && !wouldCollideWithFooter) {
          // Make it fixed
          $sidebox.css({
            position: 'fixed',
            top: headerHeight + 'px',
            width: sideboxWidth + 'px'
          })
          isFixed = true
        } else if (!shouldBeFixed && isFixed) {
          // Make it static (scrolled back up)
          $sidebox.css({
            position: 'static',
            top: '',
            width: ''
          })
          isFixed = false
        } else if (wouldCollideWithFooter && isFixed) {
          // Make it static to prevent footer collision
          $sidebox.css({
            position: 'static',
            top: '',
            width: ''
          })
          isFixed = false
        }
      }, 50))
    }

    $('.js-back-to-top').on('click', function() {
      $('html, body').animate({
        scrollTop: 0
      }, 600)
      return false
    })

  }(window.jQuery))
})
